var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFns({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9841 13.7224C59.8696 14.3142 59.5255 14.8477 59.0186 15.2027C57.1425 16.5164 56.652 19.0533 57.9058 20.844C59.1684 22.6472 61.6972 23.0591 63.5691 21.7775C64.6228 21.0541 66.0075 21.1375 66.7169 22.1506L71.1228 28.443C74.8313 33.7392 73.4025 41.1411 67.9269 44.9752L59.6625 50.762C58.808 51.3604 57.647 51.1752 57.0682 50.3485L53.358 45.0499C52.6366 44.0196 51.2332 43.7956 50.1684 44.5412C49.1291 45.2689 48.8339 46.6823 49.5553 47.7126L53.2654 53.0112C53.8443 53.8379 53.6212 54.9921 52.7696 55.5885L35.3255 67.8029C29.8751 71.6194 22.4074 70.4507 18.6971 65.1519L14.2911 58.8595C13.5818 57.8464 13.9769 56.5168 15.0171 55.774C16.8641 54.4515 17.3394 51.9361 16.0768 50.1329C14.8574 48.3914 12.4593 48.0961 10.5327 49.4451C10.0256 49.8002 9.40667 49.9413 8.81117 49.8462C8.21583 49.7514 7.68668 49.4273 7.34314 48.9367L2.89427 42.5831C-0.809089 37.2941 0.632804 29.8355 6.09845 26.0084L23.5172 13.8117C24.3688 13.2154 25.5298 13.4005 26.1086 14.2273L30.506 20.5073C31.2102 21.5131 32.6564 21.7434 33.6957 21.0157C34.7605 20.2701 35.0129 18.8504 34.3087 17.8446L29.9113 11.5646C29.3325 10.7379 29.5556 9.5836 30.4101 8.98525L38.6745 3.19845C44.1501 -0.635606 51.5926 0.550888 55.3028 5.84965L59.6314 12.0315C59.9749 12.5221 60.0984 13.1302 59.9841 13.7224ZM46.8362 39.7823C47.901 39.0367 48.1533 37.6168 47.449 36.611L40.5782 26.7984C39.8739 25.7926 38.4535 25.5444 37.3888 26.2899C36.3494 27.0177 36.0712 28.4553 36.7755 29.4611L43.6463 39.2737C44.3506 40.2795 45.7969 40.51 46.8362 39.7823Z",
    fill: "url(#paint0_linear_4264_6151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4264_6151",
    x1: -18.5206,
    y1: 43.2469,
    x2: 27.1157,
    y2: 108.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFns);
export default __webpack_public_path__ + "static/media/stats-fns.06b7180f2e5d79ef554dbf657658f8fe.svg";
export { ForwardRef as ReactComponent };